module.exports = __webpack_public_path__ + "static/img/500.1aa96fdd.png";